export default __webpack_public_path__ + "static/media/anunciantes.1d5be56c.png";